import ShopView from './containers/ShopView';

import React from 'react';

export default ShopView;

export {uiDataShopView, serverDataShopView} from './reducers/ShopView';